import { render } from "./Typed.vue?vue&type=template&id=604a2db3"
import script from "./Typed.vue?vue&type=script&lang=js"
export * from "./Typed.vue?vue&type=script&lang=js"

import exportComponent from "/home/pomelos/Projects/stowy-web-prod/stowy-web/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__